"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewAction = void 0;

var _react = require("@lingui/react");

var React = _interopRequireWildcard(require("react"));

var _context = require("./context");

var _utils = require("./utils");

var _ActionDetail = require("./components/ActionDetail");

var Elements = _interopRequireWildcard(require("../ActionModal.styles"));

var _LoadingOverlay = require("../components/LoadingOverlay");

var _Activity = require("./components/Activity");

var _actionField = require("../../../context/actionField");

var _attachments = require("../../../context/attachments");

const ViewAction = /*#__PURE__*/React.memo(({
  onClose,
  onActionChange
}) => {
  const {
    actionStatus,
    isOpen,
    action,
    actionId,
    addMessageStatus
  } = (0, _context.useState)();
  const {
    hideModal,
    loadAction,
    loadMessages,
    setAction,
    loadMentionsList,
    clearAction
  } = (0, _context.useActions)();
  const actionLabel = `#${(0, _utils.stripProjectPrefix)(actionId)}`;
  const handleActionChange = React.useCallback(function handleActionChange(updated) {
    setAction(updated); // If status is being updated, refresh messages
    // to display the new status transition message.

    if (action !== undefined && action.bonfire_status !== updated.bonfire_status) {
      void loadMessages(action.key);
    }

    if (onActionChange !== undefined) {
      onActionChange(updated);
    }
  }, [action]);
  React.useEffect(() => {
    if (actionId !== undefined && isOpen && actionStatus === _context.Status.idle) {
      void loadAction(actionId);
    }
  }, [isOpen, actionId, actionStatus]);
  React.useEffect(() => {
    if (actionStatus === _context.Status.ready && action !== undefined) {
      void loadMentionsList(action.project_key, action.components);
    }
  }, [actionStatus]);
  return /*#__PURE__*/React.createElement(Elements.Modal, {
    title: /*#__PURE__*/React.createElement(Elements.Title, null, /*#__PURE__*/React.createElement(_react.Trans, {
      id: "view_action_modal.header_title",
      values: {
        actionLabel: actionLabel
      }
    })),
    isOpen: isOpen,
    onRequestClose: () => {
      if (addMessageStatus !== _context.Status.idle) return;
      clearAction();
      hideModal(onClose);
    }
  }, /*#__PURE__*/React.createElement(Elements.Content, null, (actionStatus === _context.Status.loading || actionId !== (action === null || action === void 0 ? void 0 : action.key)) && /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingOverlay, null), /*#__PURE__*/React.createElement(Elements.DetailsColumn, null, action !== undefined && actionStatus === _context.Status.ready && /*#__PURE__*/React.createElement(_attachments.AttachmentsProvider, null, /*#__PURE__*/React.createElement(_actionField.ActionFieldProvider, null, /*#__PURE__*/React.createElement(_ActionDetail.ActionDetail, {
    withInModal: true,
    action: action,
    onActionChange: handleActionChange
  })))), /*#__PURE__*/React.createElement(Elements.ActivityColumn, null, /*#__PURE__*/React.createElement(_Activity.Activity, {
    onNewCommentAdded: handleActionChange
  }))));
});
exports.ViewAction = ViewAction;